<div class="modal-header d-flex justify-content-center bg-light">
    <h4 class="modal-title text-center">Confirm bid<div class="modalsubheader">{{'tenders.confirmBid'|cxTranslate}}
        </div>
    </h4>
</div>
<div *ngIf="enableLoader" id="loader"></div>
<div *ngIf="!enableLoader">
    <div class="modal-body bg-light">
        <div *ngFor="let data of productInfo;let i=index">
            <div class="small text-secondary">{{ 'home.headerLinks.material' | cxTranslate }} #{{i+1}}</div>
            <div>
                <!-- <div class="small text-secondary">Material #</div> -->
                <h5 class="strong">{{data?.newName?data.newName:data.productName}}</h5>
            </div>

            <div class="d-flex justify-content-between mt-2">
                <!-- <div class="small" *ngIf="multipleProduct.commodityType=='IO'">
                    <div class="small text-secondary">{{ 'tenders.Quantity(DMT)' | cxTranslate
                        }}({{data?.displayQuantityUnitDesc}})</div>
                    <div class="strong small">{{data?.quantityshw | number}}</div>
                </div> -->
                <!-- coal specific -->
                <div class="small" >
                    <div class="small text-secondary">{{ 'tenders.Quantity(DMT)' | cxTranslate
                        }}({{data?.displayQuantityUnitDesc}})</div>
                    <div class="strong small" *ngIf="data?.quantity  && !data.minimumQuantity && !data.maximumQuantity">{{data?.quantityshw | number}}</div>
                    <div class="strong" *ngIf="data?.minimumQuantity && data?.maximumQuantity">{{data?.Quantity | number}}</div>

                    <!-- <div class="semibold strong small">130,000 - 190,000</div>-->
                </div>
                <!-- iron ore & coal specific -->
                <div class="small" *ngIf="multipleProduct.commodityType!='CN'">
                    <div class="small text-secondary" *ngIf="multipleProduct.arrivalPeriod == 'true'">
                        {{'tenders.ArrivalPeriod'| cxTranslate}}</div>
                    <div class="small text-secondary" *ngIf="multipleProduct.arrivalPeriod == 'false' && ( multipleProduct.commodityType=='CC' || multipleProduct.commodityType=='IO')">
                        {{'tenders.LoadPortLaycan'| cxTranslate}}</div>
                        <div class="small text-secondary" *ngIf="multipleProduct.arrivalPeriod == 'false' && ( multipleProduct.commodityType=='CA' )">
                            {{'tenders.schedule'| cxTranslate}}</div>
                    <div class="strong" *ngIf="multipleProduct.arrivalPeriod == 'false'">
                        {{data?.laycanStartDate | date:"dd/MM/yyyy"}} - {{data?.laycanEndDate |
                        date:"dd/MM/yyyy"}}</div>
                    <div class="strong" *ngIf="multipleProduct.arrivalPeriod == 'true'">
                        {{multipleProduct?.arrivalStartDate | date:"dd/MM/yyyy"}} - {{multipleProduct?.arrivalEndDate |
                        date:"dd/MM/yyyy"}}</div>
                </div>
            </div>
            <div *ngFor="let child of data?.childList;let j=index">
               
                <div class="d-flex justify-content-between mt-2">
                    <div class="small"
                        *ngIf="multipleProduct.commodityType=='IO'&& data.pricingOptionsEnum[0]?.pricingOptions=='FIXED_PRICE'">
                        <div class="small text-secondary">{{'tenders.YourPrice(perDMT)'|cxTranslate}} (per
                            {{data.displayFixedPriceConfig.displayFixedPriceUnitDesc}})</div>
                        <div class="strong">USD {{child?.relPrice}}</div>
                    </div>
                    <div class="small"
                        *ngIf="multipleProduct.commodityType=='IO' && (data.pricingOptionsEnum[0]?.pricingOptions=='INDEX_PRICE'||data.pricingOptionsEnum[0]?.pricingOptions=='LUMP_FIXED_PRICE') ">
                        <div *ngIf="data.pricingOptionsEnum[0]?.pricingOptions=='INDEX_PRICE'"
                            class="small text-secondary ">{{'tenders.Yourpremium'|cxTranslate}} (per
                            {{data.displayIndexPriceConfig.displayIndexPriceUnitDesc}})</div>
                        <div *ngIf="data.pricingOptionsEnum[0]?.pricingOptions=='LUMP_FIXED_PRICE'"
                            class="small text-secondary ">{{'tenders.Yourpremium'|cxTranslate}} (per
                            {{data.displayLumpFixedPriceConfig.displayLumpFixedPriceUnitDesc}})</div>
                        <div class="strong">USD {{child?.premDiscount}}</div>
                    </div>
                    <!-- coal specific -->
                    <div class="small"
                        *ngIf="multipleProduct.commodityType=='CC' && data.pricingOptionsEnum[0]?.pricingOptions=='FIXED_PRICE'">
                        <div id="67" class="small text-secondary "> {{child.productName}} {{'tenders.priceLabel'| cxTranslate}} (per
                            {{data.displayFixedPriceConfig.displayFixedPriceUnitDesc}})</div>
                        <div class="strong">USD {{child?.relPrice}}</div>
                    </div>
                    <div class="small"
                        *ngIf="multipleProduct.commodityType=='CC' && data.pricingOptionsEnum[0]?.pricingOptions=='INDEX_PRICE'">
                        <div class="small text-secondary ">{{child.productName}} {{'tenders.priceLabel'| cxTranslate}} </div>
                        <div class="strong"> {{child?.premDiscount}} %</div>
                    </div>
                </div>

            </div>
            <div *ngIf="multipleProduct.commodityType!='CN' && data?.childList==undefined">
                <div class="d-flex justify-content-between mt-2">
                    <div class="small"
                        *ngIf="multipleProduct.commodityType=='IO'&& data.pricingOptionsEnum[0]?.pricingOptions=='FIXED_PRICE'">
                        <div class="small text-secondary">{{'tenders.YourPrice(perDMT)'|cxTranslate}}(per
                            {{data.displayFixedPriceConfig.displayFixedPriceUnitDesc}})</div>
                        <div class="strong">USD {{data?.relPrice}}</div>
                    </div>
                    <div class="small"
                        *ngIf="(multipleProduct.commodityType=='IO' || multipleProduct.commodityType=='CA')   && (data.pricingOptionsEnum[0]?.pricingOptions!='FIXED_PRICE') ">
                        <div id="91" *ngIf="data.pricingOptionsEnum[0]?.pricingOptions=='INDEX_PRICE'" class="small text-secondary "> Your
                            premium/discount (per
                            {{data.displayIndexPriceConfig.displayIndexPriceUnitDesc}})</div>
                        <div id="94" *ngIf="data.pricingOptionsEnum[0]?.pricingOptions=='LUMP_FIXED_PRICE'" class="small text-secondary "> Your
                            premium/discount (per
                            {{data.displayLumpFixedPriceConfig.displayLumpFixedPriceUnitDesc}})</div>
                        <div id="98" *ngIf="data.pricingOptionsEnum[0]?.pricingOptions=='FIXED_PREMIUM'" class="small text-secondary "> Your
                            premium (per
                            {{data.displayFixedPremiumConfig.displayFixedPremiumUnitDesc}})</div>
                        <div *ngIf="data.pricingOptionsEnum[0]?.pricingOptions!='FLOATING_PREMIUM'" class="strong">USD {{data?.premDiscount || 0}}</div>
                        
                    
                    </div>
                    <!-- coal specific -->
                    <div class="small"
                        *ngIf="multipleProduct.commodityType=='CC' && data.pricingOptionsEnum[0]?.pricingOptions=='FIXED_PRICE'">
                        <div class="small text-secondary ">{{'tenders.YourPrice(perDMT)'|cxTranslate}} (per
                            {{data.displayFixedPriceConfig.displayFixedPriceUnitDesc}})</div>
                        <div class="strong">USD {{data?.relativePrice.value}}</div>
                    </div>
                    <div class="small"
                        *ngIf="multipleProduct.commodityType=='CC' && (data.pricingOptionsEnum[0]?.pricingOptions=='INDEX_PRICE' || data.pricingOptionsEnum[1]?.pricingOptions=='LUMP_FIXED_PRICE')">
                        <div class="small text-secondary ">Your price</div>
                        <div class="strong"> {{data?.premiumDiscount.value}} %</div>
                    </div>
                </div>

            </div>
            <div
                *ngIf="data.pricingOptionsEnum[0]?.pricingOptions!='FIXED_PRICE'">
                <div *ngIf="multipleProduct.commodityType!='CA'" class="small text-secondary ">{{'tenders.Pricingbasis' | cxTranslate}}</div>
                <div *ngIf="multipleProduct.commodityType=='CA'" class="small text-secondary ">{{'tenders.OnlyPrice' | cxTranslate}}</div>
                
                <div class="small" *ngFor="let Pricingbasis of data.pricingBasis">
                    {{getPricingBasisBasedOnOption(data.pricingOptionsEnum[0]?.pricingOptions,Pricingbasis.description)}}
                </div>
            </div>
            <div *ngIf="(data.pricingOptionsEnum[0]?.premiumIndex!='' && data.pricingOptionsEnum[0]?.premiumIndex!=undefined)"
                class="form-group">
                <div class="small text-secondary ">{{'tenders.Premium' | cxTranslate}}</div>
                <div class=" small">
                    {{data.pricingOptionsEnum[0]?.premiumIndex}}</div>
            </div>
            
            <div
                *ngIf="data.pricingOptionsEnum[0]?.pricingOptions=='INDEX_PRICE' || data.pricingOptionsEnum[0]?.pricingOptions=='FIXED_PREMIUM' || data.pricingOptionsEnum[0]?.pricingOptions=='FLOATING_PREMIUM'
                 || data.pricingOptionsEnum[0]?.pricingOptions=='LUMP_FIXED_PRICE'">
                <div class="small text-secondary mt-2">{{'tenders.QuotationPeriod'| cxTranslate}}</div>
                <div *ngIf="data.isQuotationPeriodUnrestricted == false && data.isQPMultipleChoicesSelected == false" class="small">{{formatQPDates(data)}}</div>
                                 
                    <div *ngIf="data.isQPMultipleChoicesSelected === true " class="small">
                        <p *ngIf="data.pricingOptionsEnum[0]?.qp[0].description != 'Fixed QP'">{{data.pricingOptionsEnum[0]?.qp[0].description}}</p>
                        <p *ngIf="data.pricingOptionsEnum[0]?.qp[0].description == 'Fixed QP'">{{getDate(data.finalQPFromDate)}} - {{getDate(data.finalQPToDate)}} (both dates inclusive)</p>
                    </div>
                <div *ngIf="data.isQPMultipleChoicesSelected ==false && data.isQuotationPeriodUnrestricted == true  && data.finalQPFromDate && data.finalQPToDate"
                    class="small">{{getDate(data.finalQPFromDate)}} - {{getDate(data.finalQPToDate)}} (both dates
                    inclusive)</div>
            </div>
            <hr>
        </div>
        <div class="mt-4" *ngIf="multipleProduct.commodityType!='IO'">
            <p class="mb-2 xs-semibold-font">{{'tenders.BuyerRemarks'|cxTranslate}}</p>
            <textarea class="form-control w-100 border" maxlength="5000"
                placeholder="{{ 'home.productHeader.bindingTermsPh' | cxTranslate }}"
                [(ngModel)]="additionalTerms"></textarea>
        </div>
    </div>

    <div class="modal-footer bg-light">
        <div class="w-100 text-center">
            <p class="mb-2 xs-semibold-font">{{confirmTxt}}</p>
        </div>
        <div class="w-100">
            <!-- <button class="btn btn-block btn-primary" type="submit" (click)="navigateToQuote(productInfo,quantitySelected)" data-dismiss="modal" [disabled]="startDate == null || disabledBtn || productInfo.priceValue =='' || productInfo.priceValue == 0 || productInfo.priceValue < productInfo.minPrice"> -->
            <button class="btn btn-block btn-primary btn-lg" type="submit" (click)="submitBid()">
                {{ 'home.productHeader.ConfirmBid' | cxTranslate }}
            </button>
            <div class="d-flex justify-content-between mt-2">
                <button class="btn btn-lg btn-light button" type="button" (click)="backToPlacebid()">{{'tenders.Back'|
                    cxTranslate}}</button>
                <button class="btn btn-lg btn-light button" type="button" (click)="activeModal.dismiss('close click')"
                    data-dismiss="modal">{{ 'home.productHeader.Close' | cxTranslate }}</button>
            </div>
        </div>
    </div>
</div>